import { API_PREFIX } from "../../../config/helpers";

export const promocodeRequest = (request) => fetch(`${API_PREFIX}/${request}`)
  .then((response) => {
    if (response.ok) {
      return response.json();
    }
    return Promise.reject(response);
  });
